import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ENGImitra from './ENGImitra';
import CoursesPage from './CoursesPage';
import CourseDetailsPage from './CourseDetailsPage';
import NotesPage from './NotesPage';
import MPQsPage from './MPQsPage';
import NoteDetailsPage from './NoteDetailsPage';
import MPQDetailsPage from './MPQDetailsPage';
import LegalPage from './LegalPage';
import AuthPage from './AuthPage';
import AccountDetailsPage from './AccountDetailsPage';
import CartPage from './CartPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ENGImitra />} />
        <Route path="/courses" element={<CoursesPage />} />
        <Route path="/course/:id" element={<CourseDetailsPage />} />
        <Route path="/notes" element={<NotesPage />} />
        <Route path="/note/:id" element={<NoteDetailsPage />} />
        <Route path="/mpqs" element={<MPQsPage />} />
        <Route path="/mpq/:id" element={<MPQDetailsPage />} />
        
        {/* Authentication & Account */}
        <Route path="/login" element={<AuthPage type="login" />} />
        <Route path="/signup" element={<AuthPage type="signup" />} />
        <Route path="/account" element={<AccountDetailsPage />} />
        <Route path="/cart" element={<CartPage />} />

        {/* Legal Pages */}
        <Route path="/privacy-policy" element={<LegalPage type="privacy" />} />
        <Route path="/terms" element={<LegalPage type="terms" />} />
        <Route path="/refund-policy" element={<LegalPage type="refund" />} />
        <Route path="/contact" element={<LegalPage type="contact" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;